import { render, staticRenderFns } from "./DeviceDetailsScreen.vue?vue&type=template&id=d0380522"
import script from "./DeviceDetailsScreen.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports